export default __webpack_public_path__ + "static/media/about.e5b8415b.mp4";